import styled from "styled-components";

const StyledSkeleton = styled.div`
  background-color: var(--accent, #f3f3f3);
  border-radius: 0.375rem;
  animation: pulse 1.5s ease-in-out 0.5s infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }
`;

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <StyledSkeleton data-slot="skeleton" className={className} {...props} />
  );
}

export { Skeleton };
